export default __webpack_public_path__ + "static/media/aviso-de-privacidad.a12d6ffa.svg";